/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import TextField from '@material-ui/core/TextField';
import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isCheckDateFormat } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../../../SharedModules/Dialog/CommonModal';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { RadioGroupComponent } from '../../../../../Display/Claim/component/SelectClaim/SelectClaimSearchComponent';
import {
  NDCDetailsTextFieldComponent,
  ProviderIdDetailsTextFieldComponent,
} from '../../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import {
  setActionsTypeAction,
  setPlanTypeAction,
  setSelectTypeAction,
  getDrugFamilyCode,
  ProcessDrugFamilyCode,
  setDrugFAMILYProcessResponse,
  setErrorMessage,
  getRebateProgramCode,
} from '../store/action';
import { getProviderIdTypeDetails } from '../../../../../Display/Provider/store/action';
import {
  ACTIONS_OPTIONS,
  PLAN_TYPE_DATA,
  SELECTED_BY_OPTIONS,
  textFieldLabelFrom,
  textFieldLabelTo,
} from '../utils/constant';
import {
  STARTDATE_REQUIRED,
  ENDDATE_REQUIRED,
  SUCCESSMESSAGE_PRICE,
  FAILED_MESSAGE_GENERIC,
  ERRORMESSAGE_NDC_NOT_EMPTY,
  DRUG_SELECTION_ERR,
  JIRA_NUMBER_ERROR,
  REBATE_SELECT,
  START_TIME_ERROR,
  PROVIDER_ID,
  CUSTOM_ERR_CLUASE,
  ING_MSG,
  DTRNG_MSG,
  NO_CLAIM_FOUND,
  START_DATE_REQUIRED,
  DATE_INVALID_FORMAT_ERROR,
} from '../../../../../../SharedModules/Errors/constantMessageData';
import RequestedPreviousNDCTabs from './RequestedPreviousNDCTabs';
import RequestPreviousClaimDrugFamily from './RequestPreviousClaimDrugFamily';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';
import {
  dateFormat,
  dateFormatForDatePicker,
} from '../../../../../../SharedModules/CommonConstants/commonConstants';
import moment from 'moment';
import { validDate } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
import MenuItem from '@material-ui/core/MenuItem';
import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

const RequestedPreviousClaimHeader = ({
  setErrorMessages,
  setLoading,
  setSuccessMessages,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [rebateProgram, setRebateProgram] = useState(null);
  const [rebateData, setRebateData] = useState([]);
  const [providedID, setProviderID] = useState('ALL');
  const [providerIdList, setProviderIdList] = useState([]);
  const [paidDateRange, setPaidDateRange] = useState({
    paidDateRangeFrom: null,
    paidDateRangeTo: null,
  });
  const [startTeamNumber, setStartTeamNumber] = useState();
  // const logInUserID = localStorage.getItem('logInUser');
  const [drugFamilyRow, setDrugFamilyRow] = useState();
  const [paidDateRangeError, setPaidDateRangeError] = useState({
    paidDateRangeFrom: null,
    paidDateRangeTo: null,
  });
  const [rbtErr, setRbtErr] = React.useState(false);
  const [provErr, setProvErr] = React.useState(false);
  const [starErr, setStarErr] = React.useState(false);
  const [clauseErr, setClauseErr] = React.useState(false);
  const [providerId, setProviderId] = useState('');
  const [whereClause, setwhereClause] = useState('');
  const [drugSeqNumSel, setDrugSeqNumSel] = useState([]);
  const [planType, setPlanType] = useState(null);
  const [selectType, setSelectType] = useState('INELEGPRO');
  const [jiraNumInEl, setJiraNumInEl] = useState('');
  const [jiraNumDrgFMLY, setJiraNumDrgFMLY] = useState('');
  const [proceedFlag, setProceedFlag] = React.useState(false);
  const [proIdListVal, setProIdListVal] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [dateFlag, setDateFlag] = useState(false);
  const [providrFlag, setProvidrFlag] = useState(false);
  const [IngResponse, setIngResponse] = useState();
  const [saveFlag, setSaveFlag] = useState(false);
  const [spProceedFlag, setSpProceedFlag] = React.useState(false);
  const [pageLoad, setPageLoad] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [userConfirmed, setUserConfirmed] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);
  const [open, setOpen] = React.useState(false);
  const rebateDropdownData = useSelector(
    (state) => state?.sharedState?.requestedPreviousClaim?.rebateDropdownData
  );
  const logInUserID = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const payload = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerIdType
  );
  const searchScrErr = useSelector(
    (state) => state?.sharedState?.requestedPreviousClaim.searchScrErr
  );
  const ndcDetailsTableRowSelected = useSelector(
    (state) => state.sharedState.ndc.ndcDetailsTableRowSelected
  );
  const labelerDrugTableData = useSelector(
    (state) => state.sharedState.ndc.labelerDrugTableData
  );
  const userDefault = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const defaultRebateProgramCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const ndcDetailsTableData = useSelector(
    (state) => state.sharedState.ndc.ndcDetailsTableData
  );
  const ndcLoading = useSelector((state) => state.sharedState?.ndc?.loading);

  useEffect(() => {
    setLoading(ndcLoading);
  }, [ndcLoading]);
  useEffect(() => {
    if (ndcDetailsTableData) {
      const drugSeqNums = ndcDetailsTableData.map((row) => row.drugSeqNum);
      setDrugSeqNumSel(drugSeqNums);
    }
  }, [ndcDetailsTableData]);

  const { actionType, drugFamilyCode, selectedRow, processResponse } =
    useSelector((state) => state?.sharedState?.requestedPreviousClaim);
  const handleChangeID = (e) => {
    setErrorMessages([]);
    setProviderID(e.target.value);
  };
  useEffect(() => {
    dispatch(getProviderIdTypeDetails());
  }, []);
  useEffect(() => {
    const data = [
      {
        codeDomainKey: null,
        codeValue: null,
        codeValueID: {
          codeDomainKey: 'All',
          codeValue: 'all',
        },
      },
    ];
    if (providerIdList.length > 0) {
      const proIdAllVal = [];
      providerIdList.forEach((item) =>
        proIdAllVal.push(item?.codeValueID?.codeValue)
      );
      providerIdList.unshift(data);

      setProIdListVal(proIdAllVal);
    }
    setProviderIdList(payload);
    setProviderID(payload[0]?.codeValueID?.codeValue);
  }, [payload]);
  useEffect(() => {
    setDrugFamilyRow(selectedRow);
  }, [selectedRow]);
  useEffect(() => {
    setLoading(false);
  }, [processResponse]);

  useEffect(() => {
    if (!pageLoad) processData();
  }, [dateFlag, providrFlag, saveFlag, proceedFlag, spProceedFlag]);

  useEffect(() => {
    if (userDefault && !planType) {
      if (userDefault.planTypeCd) {
        setPlanType(userDefault.planTypeCd);
      } else {
        setPlanType(PLAN_TYPE_DATA[0].value);
      }
    }
  }, [userDefault]);

  useEffect(() => {
    if (planType) {
      dispatch(getRebateProgramCode(planType));
    }
  }, [planType]);

  useEffect(() => {
    if (!rebateProgram) {
      if (
        rebateDropdownData &&
        rebateDropdownData.length > 0 &&
        defaultRebateProgramCd
      ) {
        const filterArr = rebateDropdownData.filter(
          (item) => item.value === defaultRebateProgramCd
        );

        if (filterArr.length > 0) {
          setRebateProgram(filterArr[0].value);
        }
      }
    }
  }, [rebateDropdownData, defaultRebateProgramCd]);

  const onPlanTypeChange = (type) => {
    setRebateProgram(null);
    setPlanType(type);
  };

  const onSelectTypeChange = (type) => {
    setSelectType(type);
    dispatch(setSelectTypeAction(type));
    if (type === 'DRUGFAMILY' && rebateProgram != -1) {
      const payload = {
        rebateProgramCode: rebateProgram,
      };
      getDrugFamilyDetails(payload);
    }
  };

  const onActionTypeChange = (type) => {
    dispatch(setActionsTypeAction(type));
  };

  useEffect(() => {
    setRebateData(rebateDropdownData);
  }, [rebateDropdownData]);

  const showMoveButtons = () => {
    return true;
  };
  const convertDateToQuarter = (d) => {
    var date = new Date(d);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const quarter = Math.ceil(month / 3);
    return `${quarter}Q${year}`;
  };
  const validateInputs = () => {
    const errMsg = [];
    setErrorMessages([]);
    let dateerr = {
      paidDateRangeFrom: null,
      paidDateRangeTo: null,
    };
    if (!paidDateRange.paidDateRangeFrom) {
      errMsg.push(STARTDATE_REQUIRED);
      dateerr.paidDateRangeFrom = STARTDATE_REQUIRED;
    }
    if (!paidDateRange.paidDateRangeTo) {
      errMsg.push(ENDDATE_REQUIRED);
      dateerr.paidDateRangeTo = ENDDATE_REQUIRED;
    }
    setPaidDateRangeError(dateerr);
    if (rebateProgram == -1 || !rebateProgram) {
      errMsg.push(REBATE_SELECT);
      setRbtErr(true);
    }
    if (selectType === 'NDC' && ndcDetailsTableData.length === 0) {
      errMsg.push(ERRORMESSAGE_NDC_NOT_EMPTY);
    }
    if ((selectType === 'NDC' || selectType === 'SPCIR') && !startTeamNumber) {
      errMsg.push(START_TIME_ERROR);
    }
    if (selectType === 'INELEGPRO' && !providerId) {
      errMsg.push(PROVIDER_ID);
      setProvErr(true);
    }
    if (selectType === 'INELEGPRO' && !jiraNumInEl) {
      errMsg.push(JIRA_NUMBER_ERROR);
      setStarErr(true);
    }
    if (selectType === 'SPCIR' && !whereClause) {
      errMsg.push(CUSTOM_ERR_CLUASE);
      setClauseErr(true);
    }
    if (
      selectType === 'DRUGFAMILY' &&
      Object.keys(drugFamilyRow).length === 0 &&
      drugFamilyRow.constructor === Object
    ) {
      errMsg.push(DRUG_SELECTION_ERR);
    }
    if (selectType === 'DRUGFAMILY' && !jiraNumDrgFMLY) {
      errMsg.push(JIRA_NUMBER_ERROR);
      setStarErr(true);
    }
    if (errMsg.length > 0) {
      setErrorMessages(errMsg);
      return false;
    }
    return true;
  };
  const convertToFormat = (d) => {
    const formatDate = new Date(d);
    let year = formatDate.getFullYear();
    let month = (1 + formatDate.getMonth()).toString().padStart(2, '0');
    let day = formatDate.getDate().toString().padStart(2, '0');

    return month + '/' + day + '/' + year;
  };

  const processData = async () => {
    if (!validateInputs()) {
      return;
    }
    // setOpen(true);
    if (selectType === 'DRUGFAMILY') {
      const payload = {
        paidBeginQtr: convertDateToQuarter(paidDateRange.paidDateRangeFrom),
        paidEndQtr: convertDateToQuarter(paidDateRange.paidDateRangeTo),
        selectedBy: selectType,
        paidDateBeginDt: convertToFormat(paidDateRange.paidDateRangeFrom),
        paidDateEndDt: convertToFormat(paidDateRange.paidDateRangeTo),
        rpc: rebateProgram,
        userId: logInUserID,
        drugFamilySeqNum: selectedRow?.familySeqNum,
        proceedFlag: true,
        invoiceFlag: actionType == 'INVOICE' ? true : false,
        planTypeCd: planType,
      };
      try {
        setLoading(true);
        const response = await axios.post(
          `${serviceEndPoint.PROCESS_DRUG_FAMILY_DETAILS}`,
          payload
        );
        setLoading(false);
        if (response?.data?.status === 500) {
          setErrorMessages([response?.data?.data]);
        }

        if (response?.data?.status === 400) {
          setErrorMessages([response?.data?.data]);
        }

        dispatch(setDrugFAMILYProcessResponse(payload));
      } catch (e) {
        if (e.response && e.response.status === 400) {
          setErrorMessages([e.response.data]);
        } else {
          dispatch(setErrorMessages([e]));
        }
      }
    } else if (selectType === 'SPCIR') {
      const payload = {
        paidBeginQtr: convertDateToQuarter(paidDateRange.paidDateRangeFrom),
        paidEndQtr: convertDateToQuarter(paidDateRange.paidDateRangeTo),
        paidDateBeginDt: convertToFormat(paidDateRange.paidDateRangeFrom),
        paidDateEndDt: convertToFormat(paidDateRange.paidDateRangeTo),
        rpc: rebateProgram,
        userId: logInUserID,
        note: startTeamNumber,
        invoiceFlag: actionType == 'INVOICE' ? true : false,
        planTypeCd: planType,
        splCircumstances: whereClause,
        proceedFlag: spProceedFlag,
      };
      try {
        setLoading(true);
        const response = await axios.post(
          `${serviceEndPoint.PROCESS_SPECIAL_CIRCUMTANCES}`,
          payload
        );
        setErrorMessages([]);
        setSuccessMessages([]);
        setLoading(false);
        if (response?.status === 200) {
          if (response.data === NO_CLAIM_FOUND) {
            setErrorMessages([response.data]);
          } else {
            setSuccessMessages([SUCCESSMESSAGE_PRICE]);
            // setTimeout(() => setSuccessMessages([]), 5000);
            setPageLoad(true);
            setSpProceedFlag(false);
          }
        } else {
          setErrorMessages([FAILED_MESSAGE_GENERIC]);
        }
      } catch (e) {
        setLoading(false);
        if (e?.response?.status === 400) {
          const response = e.response;
          if (
            response.data.indexOf(
              'numbers of claims will be inserted into Omitted_Claim_Inv. Do you want to proceed?'
            ) >= 0
          ) {
            let dummyResponse = { message: response.data, type: 'SP' };
            setShowPopup(true);
            setPopupMessage(response.data);
            setIngResponse(dummyResponse);
            setPageLoad(false);
          } else {
            setErrorMessages([response.data]);
          }
        }
        // setErrorMessages([FAILED_MESSAGE_GENERIC]);
      }
    } else if (selectType === 'NDC') {
      const payload = {
        paidBeginQtr: convertDateToQuarter(paidDateRange.paidDateRangeFrom),
        paidEndQtr: convertDateToQuarter(paidDateRange.paidDateRangeTo),
        paidDateBeginDt: convertToFormat(paidDateRange.paidDateRangeFrom),
        paidDateEndDt: convertToFormat(paidDateRange.paidDateRangeTo),
        userId: logInUserID,
        note: startTeamNumber,
        invoiceFlag: actionType == 'INVOICE' ? true : false,
        planTypeCd: planType,
        drugSeqNum: drugSeqNumSel,
        rebateProgramCd: rebateProgram,
        rpc: rebateProgram,
        saveFlag: saveFlag,
      };
      try {
        setLoading(true);
        const response = await axios.post(
          `${serviceEndPoint.PROCESS_NDC}`,
          payload
        );
        setErrorMessages([]);
        setSuccessMessages([]);
        setLoading(false);

        if (response?.status === 200) {
          const isDataNumber = typeof response.data === 'number';
          //const isDataStringWithNumber = !isNaN(response.data);
          if (isDataNumber) {
            let dummyResponse = {
              message: response.data,
              type: 'N',
            };
            setOpenModal(true);
            setPopupMessage(
              `${response.data} numbers of claims will be inserted into Omitted_Claim_Inv. Do you want to proceed?`
            );
            setIngResponse(dummyResponse);
            setPageLoad(false);
          } else {
            setSuccessMessages([SUCCESSMESSAGE_PRICE]);
            // setTimeout(() => setSuccessMessages([]), 5000);
          }
        } else {
          setErrorMessages([response?.data?.data]);
        }
      } catch (e) {
        setErrorMessages([]);
        setSuccessMessages([]);
        if (e?.response?.status === 400) {
          setErrorMessages([e?.response?.data?.data]);
        } else {
          setErrorMessages([FAILED_MESSAGE_GENERIC]);
        }
      }
    } else if (selectType === 'INELEGPRO') {
      const payloadINE = {
        providerId: providerId,

        providerIdTypeCd: providedID,
        ineligProviderBeginDt: convertToFormat(paidDateRange.paidDateRangeFrom),
        dateFlag: dateFlag,
        rebateProgramCd: rebateProgram,
        paidDateBeginDt: convertToFormat(paidDateRange.paidDateRangeFrom),
        paidDateEndDt: convertToFormat(paidDateRange.paidDateRangeTo),
        endDt: convertToFormat(paidDateRange.paidDateRangeTo),
        rpc: rebateProgram,
        providerIdFlag: providrFlag,
        planTypeCd: planType,
        proceedFlag: proceedFlag,
        paidBeginQtr: convertDateToQuarter(paidDateRange.paidDateRangeFrom),
        paidEndQtr: convertDateToQuarter(paidDateRange.paidDateRangeTo),
        userId: logInUserID,
      };
      setLoading(true);
      try {
        const response = await axios.post(
          `${serviceEndPoint.PROCESS_INELIGIBLE_PROVIDE}`,
          payloadINE
        );
        setLoading(false);
        if (response?.status === 200) {
          setShowPopup(false);
          setSuccessMessages([SUCCESSMESSAGE_PRICE]);
          // setTimeout(() => setSuccessMessages([]), 5000);
          setPageLoad(true);
          setDateFlag(false);
          setProvidrFlag(false);
          setProceedFlag(false);
        }
      } catch (e) {
        setErrorMessages([]);
        setSuccessMessages([]);
        setLoading(false);
        if (e?.response?.status === 400) {
          const response = e.response;
          if (response.data == DTRNG_MSG) {
            let dummyResponse = {
              message: response.data,
              type: 'D',
            };
            setShowPopup(true);
            setPopupMessage(response.data);
            setIngResponse(dummyResponse);
            setPageLoad(false);
          } else if (response.data === ING_MSG) {
            let dummyResponse = {
              message: response.data,
              type: 'I',
            };
            setShowPopup(true);
            setPopupMessage(response.data);
            setIngResponse(dummyResponse);

            setPageLoad(false);
          } else if (
            response.data.indexOf(
              'numbers of claims will be inserted into Omitted_Claim_Inv. Do you want to proceed?'
            ) >= 0
          ) {
            let dummyResponse = { message: response.data, type: 'P' };
            setShowPopup(true);
            setPopupMessage(response.data);
            setIngResponse(dummyResponse);
            setPageLoad(false);
          } else {
            setErrorMessages([e?.response.data]);
          }
        } else {
          setErrorMessages([FAILED_MESSAGE_GENERIC]);
        }
      }
    }
  };

  const rebateProgramChangeHandler = (e) => {
    const program = e.target.value;

    setRebateProgram(program);
    if (program != -1 && program) {
      if (selectType === 'DRUGFAMILY') {
        const payload = {
          rebateProgramCode: program,
        };
        getDrugFamilyDetails(payload);
        setDrugFamilyRow({});
      }
      setRbtErr(false);
    } else setRbtErr(true);
  };

  const navigateToPage = (pathname, value) => {
    let updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathname) === -1) {
      updateTabs.push({
        navTo: pathname,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({ pathname });
  };

  const handleDateChangeEvent = (type, value) => {
    const errors = { ...paidDateRangeError };
    let errMsg = [];
    if (value !== 'Invalid Date') {
      const newrange = { ...paidDateRange, [type]: value };
      setPaidDateRange(newrange);
      errors[type] = null;
      let invalidDates = false;

      if (type === 'paidDateRangeFrom') {
        invalidDates = isToDateLessThanFromDate(
          value,
          paidDateRange.paidDateRangeTo
        );
      } else if (type === 'paidDateRangeTo') {
        invalidDates = isToDateLessThanFromDate(
          paidDateRange.paidDateRangeFrom,
          value
        );
      }
      if (invalidDates) {
        if (type === 'paidDateRangeFrom') {
          errors['paidDateRangeTo'] = null;
          errors[type] = `End date can't be less than Start date`;
        } else if (type === 'paidDateRangeTo') {
          errors['paidDateRangeFrom'] = null;
          errors[type] = `End date can't be less than Start date`;
        }
      } else {
        errors['paidDateRangeTo'] = null;
        errors['paidDateRangeFrom'] = null;
      }

      setPaidDateRangeError(errors);
      if (errors['paidDateRangeTo'] != null) {
        errMsg.push(errors['paidDateRangeTo']);
      }
      if (errors['paidDateRangeFrom'] != null) {
        errMsg.push(errors['paidDateRangeFrom']);
      }
    } else {
      errors[type] = 'Please enter date in MM/DD/YYYY format';
      if (
        errMsg.filter((x) => x == 'Please enter date in MM/DD/YYYY format')
          .length == 0
      ) {
        errMsg.push('Please enter date in MM/DD/YYYY format');
      }
    }

    setErrorMessages(errMsg);
  };

  const getDrugFamilyDetails = (payload) => {
    dispatch(getDrugFamilyCode(payload));
  };

  const isToDateLessThanFromDate = (fromDate, toDate) => {
    let isInvalidDate = false;
    if (fromDate && toDate) {
      isInvalidDate = Date.parse(fromDate) - Date.parse(toDate) > 0;
    }
    return isInvalidDate;
  };

  const convert2DDate = (value) => {
    const errorMessages = [];
    let errorDate = false;
    const regex = new RegExp(/^[0-9/]+$/);
    const invoiceDate = value;
    const sptDate = invoiceDate;
    const splitDate =
      sptDate && sptDate.length > 0 && sptDate.includes('/')
        ? sptDate.split('/')
        : sptDate;
    if (sptDate[0] && !regex.test(sptDate[0])) {
      errorDate = true;
    }
    if (!validDate(new Date(value)) && splitDate[2]?.length !== 2) {
      errorDate = true;
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2].length == 1 || splitDate[0] > 12)
    ) {
      errorDate = true;
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2] == 0 || splitDate[1] == 0 || splitDate[0] == 0)
    ) {
      errorDate = true;
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2].length == 3 || splitDate[2].length == 1)
    ) {
      errorDate = true;
    }
    if (
      splitDate.length == 2 &&
      (splitDate[1].length == 1 || splitDate[0] > 12)
    ) {
      errorDate = true;
    }
    if (splitDate.length == 2 && (splitDate[1] == 0 || splitDate[0] == 0)) {
      errorDate = true;
    }
    if (invoiceDate && splitDate.length == 1) {
      errorDate = true;
    }
    if (errorDate) {
      return false;
    } else {
      let finalDate = value;

      const sptDate =
        invoiceDate && invoiceDate.includes('_')
          ? invoiceDate.split('_')
          : invoiceDate;
      const invDate =
        sptDate && sptDate.length > 0 && sptDate.includes('/')
          ? sptDate.split('/')
          : sptDate;
      const dateLength = invDate.length;

      if (dateLength == 2 && invDate[1].length == 2) {
        const years2D =
          invDate[1].length == 2 && invDate[1] < 43
            ? `20${invDate[1]}`
            : `19${invDate[1]}`;
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/` + '01' + `/${years2D}`;
      } else if (dateLength == 2 && invDate[1].length == 4) {
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/` + '01' + `/${invDate[1]}`;
      } else if (dateLength == 3 && invDate[2].length == 2) {
        const years2D =
          invDate[2].length == 2 && invDate[2] < 43
            ? `20${invDate[2]}`
            : `19${invDate[2]}`;
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/${invDate[1]}/${years2D}`;
      } else if (dateLength == 3 && invDate[2].length == 4) {
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        const day = invDate[1].length < 2 ? `0${invDate[1]}` : invDate[1];
        finalDate = `${month}/${day}/${invDate[2]}`;
      }
      return finalDate;
    }
  };
  const handleOnblurEvent = (type, dateVal) => {
    setErrorMessages([]);
    let errMsg = searchScrErr || [];
    const errors = { ...paidDateRangeError };

    const value = convert2DDate(dateVal?.replace('__', ''));
    if (value && isCheckDateFormat(value)) {
      errors[type] = null;
      let invalidDates = false;

      if (type === 'paidDateRangeFrom') {
        invalidDates = isToDateLessThanFromDate(
          value,
          paidDateRange.paidDateRangeTo
        );
      } else if (type === 'paidDateRangeTo') {
        invalidDates = isToDateLessThanFromDate(
          paidDateRange.paidDateRangeFrom,
          value
        );
      }
      if (invalidDates) {
        if (type === 'paidDateRangeFrom') {
          errors['paidDateRangeTo'] = null;
          errors[type] = `Start date can't be greater than End date`;
        } else if (type === 'paidDateRangeTo') {
          errors['paidDateRangeFrom'] = null;
          errors[type] = `End date can't be less than Start date`;
        }
        if (errors['paidDateRangeTo'] != null) {
          errMsg.push(errors['paidDateRangeTo']);
        }
        if (errors['paidDateRangeFrom'] != null) {
          errMsg.push(errors['paidDateRangeFrom']);
        }
      }
      const newrange = { ...paidDateRange, [type]: value };
      setPaidDateRange(newrange);
    } else {
      if (!value) {
        if (type === 'paidDateRangeFrom') {
          errors[type] = START_DATE_REQUIRED;
          errMsg.push(STARTDATE_REQUIRED);
        } else if (type === 'paidDateRangeTo') {
          errors[type] = ENDDATE_REQUIRED;
          errMsg.push(ENDDATE_REQUIRED);
        }
      } else {
        errors[type] = DATE_INVALID_FORMAT_ERROR;
        if (errMsg.filter((x) => x == DATE_INVALID_FORMAT_ERROR).length == 0) {
          errMsg.push(DATE_INVALID_FORMAT_ERROR);
        }
      }
    }
    setPaidDateRangeError(errors);
    if (!errors.type) {
      if (type === 'paidDateRangeFrom')
        errMsg = errMsg.filter((o) => o !== STARTDATE_REQUIRED);
      if (type === 'paidDateRangeTo')
        errMsg = errMsg.filter((o) => o !== ENDDATE_REQUIRED);
    }
    setErrorMessages(errMsg);
  };

  React.useEffect(()=>{
  setSuccessMessages([])
 },[planType, startTeamNumber, rebateProgram, rebateData, paidDateRange, selectType, jiraNumInEl, providerId])
  return (
    <>
      {!fullScreen && (
        <>
          <div className="row">
            <div className="col-4">
              <fieldset className="custom-fieldset frr-two-col-radio">
                <legend className="same-font-family">Plan Type</legend>
                <div className="p-0 mt-2 row">
                  <div className="mui-custom-form col-12 m-0">
                    <RadioGroupComponent
                      data={PLAN_TYPE_DATA}
                      value={planType}
                      onChange={(_, value) => {
                        setErrorMessages([]);
                        onPlanTypeChange(value);
                      }}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4">
              <fieldset className="custom-fieldset">
                <legend>Paid Date Range</legend>
                <div className="row">
                  <div className="col-5 mui-custom-form">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        required
                        id="begin_date"
                        data-testid="start-date"
                        label={textFieldLabelFrom}
                        mask="__/__/____"
                        InputLabelProps={{ shrink: true }}
                        format={dateFormatForDatePicker}
                        fullWidth
                        inputFormat={dateFormatForDatePicker}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        InputProps={{
                          readOnly: false,
                          autoFill: false,
                        }}
                        placeholder="MM/DD/YYYY"
                        value={paidDateRange.paidDateRangeFrom}
                        className={
                          paidDateRangeError.paidDateRangeFrom
                            ? 'mandate-fields'
                            : null
                        }
                        onChange={(e) => {
                          handleDateChangeEvent('paidDateRangeFrom', e);
                        }}
                        onBlur={(e) => {
                          handleOnblurEvent(
                            'paidDateRangeFrom',
                            e?.target?.value
                          );
                        }}
                        onKeyDown={async (e) => {
                          if (e.keyCode == 67) {
                            // copy date
                            await window.navigator?.clipboard.writeText(e?.target?.value);
                          }
                        }}
                        error={paidDateRangeError.paidDateRangeFrom}
                        helperText={paidDateRangeError.paidDateRangeFrom}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="col-5 mui-custom-form">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        required
                        id="end_date"
                        data-testid="start-date"
                        label={textFieldLabelTo}
                        mask="__/__/____"
                        InputLabelProps={{ shrink: true }}
                        format={dateFormatForDatePicker}
                        fullWidth
                        inputFormat={dateFormatForDatePicker}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        InputProps={{
                          readOnly: false,
                          autoFill: false,
                        }}
                        placeholder="MM/DD/YYYY"
                        value={paidDateRange.paidDateRangeTo}
                        className={
                          paidDateRangeError.paidDateRangeTo
                            ? 'mandate-fields'
                            : null
                        }
                        onChange={(e) => {
                          handleDateChangeEvent('paidDateRangeTo', e);
                        }}
                        onBlur={(e) => {
                          handleOnblurEvent(
                            'paidDateRangeTo',
                            e?.target?.value
                          );
                        }}
                        onKeyDown={async (e) => {
                          if (e.keyCode == 67) {
                            // copy date
                            await window.navigator?.clipboard.writeText(e?.target?.value);
                          }
                        }}
                        error={paidDateRangeError.paidDateRangeTo}
                        helperText={paidDateRangeError.paidDateRangeTo}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-4">
              <NDCDetailsTextFieldComponent
                label={'Rebate Program'}
                value={rebateProgram}
                required
                className="ml-0 with-select"
                select={true}
                selectReset={true}
                selectData={rebateData}
                disabled={false}
                onChange={rebateProgramChangeHandler}
                error={rbtErr}
                helperText={rbtErr ? REBATE_SELECT : ''}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Select By</legend>
                <div className="p-0 mt-2 row">
                  <div className="mui-custom-form col-12 m-0">
                    <RadioGroupComponent
                      data={SELECTED_BY_OPTIONS}
                      value={selectType}
                      onChange={(_, value) => {
                        setErrorMessages([]);
                        onSelectTypeChange(value);
                      }}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
            {selectType === 'INELEGPRO' ? (
              <div className="col-4">
                <NDCDetailsTextFieldComponent
                  label={'Star Team Number'}
                  maxLength={20}
                  className="ml-0"
                  disabled={false}
                  required
                  value={jiraNumInEl}
                  onChange={(e) => {
                    setJiraNumInEl(e.target.value);
                    setErrorMessages(
                      searchScrErr.filter((o) => o !== JIRA_NUMBER_ERROR)
                    );
                    if (jiraNumInEl != '') setStarErr(false);
                  }}
                  error={starErr}
                  helperText={starErr ? JIRA_NUMBER_ERROR : ''}
                />
              </div>
            ) : (
              ''
            )}
            {selectType === 'DRUGFAMILY' ? (
              <div className="col-4">
                <NDCDetailsTextFieldComponent
                  label={'Star Team Number'}
                  maxLength={20}
                  className="ml-0"
                  disabled={false}
                  required
                  value={jiraNumDrgFMLY}
                  onChange={(e) => {
                    setJiraNumDrgFMLY(e.target.value);
                    setErrorMessages(
                      searchScrErr.filter((o) => o !== JIRA_NUMBER_ERROR)
                    );
                    if (jiraNumDrgFMLY != '') setStarErr(false);
                  }}
                  error={starErr}
                  helperText={starErr ? JIRA_NUMBER_ERROR : ''}
                />
              </div>
            ) : (
              ''
            )}
            <div className="col-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Actions</legend>
                <div className="p-0 mt-2 row">
                  <div className="mui-custom-form col-12 m-0">
                    <RadioGroupComponent
                      data={ACTIONS_OPTIONS}
                      value={actionType}
                      onChange={(_, value) => onActionTypeChange(value)}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
            {selectType === 'SPCIR' ? (
              <div className="col-4">
                <div>
                  <NDCDetailsTextFieldComponent
                    label={'Star Team Number'}
                    value={startTeamNumber}
                    className="ml-0 with-select"
                    disabled={false}
                    required
                    onChange={(e) => {
                      setStartTeamNumber(e.target.value);
                      setErrorMessages(
                        searchScrErr.filter((o) => o !== JIRA_NUMBER_ERROR)
                      );
                      if (startTeamNumber != '') setStarErr(false);
                    }}
                    error={starErr}
                    helperText={starErr ? JIRA_NUMBER_ERROR : ''}
                  />
                </div>

                <div>
                  <NDCDetailsTextFieldComponent
                    label={'Custom Where Clause'}
                    maxLength={50}
                    className="ml-0"
                    disabled={false}
                    required
                    value={whereClause}
                    onChange={(e) => {
                      setwhereClause(e.target.value);
                      setErrorMessages(
                        searchScrErr.filter((o) => o !== CUSTOM_ERR_CLUASE)
                      );
                      setClauseErr(false);
                    }}
                    error={clauseErr}
                    helperText={clauseErr ? CUSTOM_ERR_CLUASE : ''}
                  />
                </div>
              </div>
            ) : selectType === 'NDC' ? (
              <div className="col-4">
                <div>
                  <NDCDetailsTextFieldComponent
                    label={'Star Team Number'}
                    value={startTeamNumber}
                    className="ml-0 with-select"
                    disabled={false}
                    required
                    onChange={(e) => {
                      setStartTeamNumber(e.target.value);
                      setErrorMessages(
                        searchScrErr.filter((o) => o !== JIRA_NUMBER_ERROR)
                      );
                      if (startTeamNumber != '') setStarErr(false);
                    }}
                    error={starErr}
                    helperText={starErr ? JIRA_NUMBER_ERROR : ''}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>{' '}
        </>
      )}

      <br />
      <br />
      {selectType === 'INELEGPRO' && (
        <div className="row">
          <div className="col-sm-4">
            <ProviderIdDetailsTextFieldComponent
              id="providerIdType"
              label={'Provider ID Type'}
              value={providedID}
              required
              className="ml-0 with-select"
              select={true}
              selectReset={true}
              selectData={providerIdList}
              disabled={false}
              onChange={handleChangeID}
            />
          </div>
          <div className="col-2">
            <NDCDetailsTextFieldComponent
              label={'Provider ID'}
              maxLength={20}
              required
              className="ml-0"
              disabled={false}
              value={providerId}
              onChange={(e) => {
                setProvErr(false);
                setErrorMessages(searchScrErr.filter((o) => o !== PROVIDER_ID));
                setProviderId(e.target.value);
              }}
              error={provErr}
              helperText={provErr ? PROVIDER_ID : ''}
            />
          </div>
        </div>
      )}
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={showPopup}
        viewAction
        viewHeader
        onOk={() => {
          if (IngResponse.type === 'I') {
            setProvidrFlag(true);
          } else if (IngResponse.type === 'D') {
            setDateFlag(true);
          } else if (IngResponse.type === 'P') setProceedFlag(true);
          else if (IngResponse.type === 'SP') setSpProceedFlag(true);
          setShowPopup(false);
        }}
        onClose={() => {
          setShowPopup(false);
        }}
        okTitle="Yes"
        closeTitle="No"
        modalTitle="Add Previous Claim to Omitted Claim Table"
        childrenComponent={<div className="p-3">{popupMessage}</div>}
      />
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={openModal}
        viewAction
        viewHeader
        onOk={() => {
          if (IngResponse.type === 'N') {
            setSaveFlag(true);
            setOpenModal(false);
          }
        }}
        onClose={() => {
          if (IngResponse.type === 'N') {
            setSaveFlag(false);
            setOpenModal(false);
          }
        }}
        okTitle="Yes"
        closeTitle="No"
        modalTitle="Add Previous Claim to Omitted Claim Table"
        childrenComponent={<div className="p-3">{popupMessage}</div>}
      />

      {selectType === 'NDC' ? (
        <RequestedPreviousNDCTabs
          setErrorMessages={setErrorMessages}
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
        />
      ) : selectType === 'DRUGFAMILY' ? (
        <div>
          <RequestPreviousClaimDrugFamily
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        </div>
      ) : (
        ''
      )}
      {!fullScreen && (
        <>
          <div className="row float-right">
            <div className="btn-wrapper mb-2">
              <div className="mt-1 ml-4 hide-on-print">
                <Button
                  className="btn-success same-font-family frr-btn-width-17 mt-4"
                  onClick={() => {
                    if (validateInputs()) setOpen(true);
                  }}
                >
                  <SVGComponent iconName="Create-new-icon" /> Process
                </Button>
              </div>
            </div>
          </div>{' '}
        </>
      )}
      <SaveCancelPopup
        open={open}
        data-testid="savePopup"
        title="Save"
        onConfim={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          processData();
          setOpen(false);
        }}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};

export default RequestedPreviousClaimHeader;
